module.exports = __webpack_public_path__ + "static/media/calendar.b883bd6f.svg";